"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _button = _interopRequireDefault(require("@ux/button"));
var _checkmark = _interopRequireDefault(require("@ux/icon/checkmark"));
const SpinDefaultContinueToCart = ({
  host,
  skipConfig
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const handleOnClick = () => {
    const url = (0, _utils.getCartContinueUrl)(host, skipConfig);
    // it is important to hold up the page before redirection so that the request to traffic can finish
    // https://confluence.godaddy.com/display/CKPT/4.+Logging+Page+Clicks
    setTimeout(() => {
      window.location.assign(url);
    }, 150);
  };
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-testid": "spin-default-continue-to-cart",
    design: "primary",
    className: "spin-default-buy-button added",
    text: formatMessage({
      id: 'addToCartContinueText'
    }),
    "aria-label": formatMessage({
      id: 'addToCartContinueText'
    }),
    icon: /*#__PURE__*/_react.default.createElement(_checkmark.default, null),
    onClick: handleOnClick
  });
};
SpinDefaultContinueToCart.propTypes = {
  host: _propTypes.default.string,
  skipConfig: _propTypes.default.bool
};
var _default = exports.default = SpinDefaultContinueToCart;